import React from 'react'
import VideoCall from '../../components/VideoCall'

function VideoCallPage() {
  return (
    <>
    <VideoCall/>
    </>
  )
}

export default VideoCallPage